<template>
  <div class="entrance-page tw:flex tw:flex-col">
    <div class="tw:flex tw:flex-1 tw:flex-col tw:items-center tw:justify-center">
      <nuxt-img
        src="img/main/usimsaicon.svg"
        width="100"
        height="100"
        alt="logo"
      />
      <h1>900만의 여행 필수품,</h1>
      <nuxt-img
        src="img/main/usimsa-logo-v2.svg"
        width="180"
        height="35"
        alt="usimsa-logo"
      />
      <p class="text-center">
        저렴하고 편리한 eSIM/USIM<br />
        데이터가 부족할 때 데이터 충전<br />
        현지에서 무료통화<br />
        다양한 혜택까지!
      </p>
    </div>
    <div class="tw:w-full tw:p-4">
      <UsdgCtaButton
        id="gtm_entrance_btn"
        size="big"
        type="fill"
        custom-class="tw:w-full"
        @click="moveHome"
      >
        유심사로 바로가기
      </UsdgCtaButton>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'center'
})

const moveHome = () => {
  navigateTo('/', { replace: true })
}
</script>

<style lang="scss" scoped>
.entrance-page {
  height: 100svh;
  h1 {
    @include body2-semibold;
    margin-top: 40px;
    margin-bottom: 5px;
  }
  p {
    margin-top: 15px;
    @include body3-medium;
    color: $gray-400;
  }
}
</style>
